import { render, staticRenderFns } from "./NavigationArrows.vue?vue&type=template&id=8d1c4d9c&scoped=true&"
import script from "./NavigationArrows.vue?vue&type=script&lang=js&"
export * from "./NavigationArrows.vue?vue&type=script&lang=js&"
import style0 from "./NavigationArrows.vue?vue&type=style&index=0&id=8d1c4d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c4d9c",
  null
  
)

export default component.exports